/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DistrictApi } from '../api/district.api';
import { switchMap, map } from 'rxjs/operators';
import { DistrictData, DistrictMst } from '../../../interfaces/masters/district';

@Injectable()
export class DistrictMstService extends DistrictData {

  constructor(private api: DistrictApi) {
    super();
  }


  list(): Observable<DistrictMst[]> {
    return this.api.list();
  }

  getById(url:string): Observable<DistrictMst>{
      return this.api.getById(url);
  }

  create(url: string, data:DistrictMst): Observable<DistrictMst> {
    return this.api.add(url,data);
  }

  update(url: string, data:DistrictMst): Observable<DistrictMst> {
    return this.api.update(url,data);
  }

  

  delete(url: string): Observable<boolean> {
    return this.api.delete(url);
  }
}
